import balances from "./balances.json";
import statsv2 from "./statsv2.json";
import config from "./config.json";
import profile2fa_setup from "./2fa_setup.json";
import noPay from "./noPay.json";
import get2faEnableMethod from "./get-2fa-enable-method.json";
import dashboard from "./dashboard.json";
import pairs from "./pairs.json";
import types from "./types.json";
import coinhold from "./coinhold.json";
import providers from "./providers.json";
import cardsConfig from "./cardsConfig.json";
import actual from "./actual.json";
import coins from "./coins.json";
import active from "./active.json";
import totals from "./totals.json";
import stakingSettings from "./stakingSettings.json";

export const dataByPath = Object.freeze({
  "/profile/balances": balances,
  "/statsv2": statsv2,
  "/coin/config": config,
  "/profile/2fa_setup": profile2fa_setup,
  "/v1/settings/no-pay": noPay,
  "/users/get-2fa-enable-method": get2faEnableMethod,
  "/v1/dashboard": dashboard,
  "/v2/exchange/pairs": pairs,
  "/v1/coinhold/types": types,
  "/v1/coinhold/list": coinhold,
  "/v2/card-details/providers": providers,
  "/v1/cards/config": cardsConfig,
  "/deposit-staking/settings/actual": actual,
  "/deposit-staking/deposit/active": active,
  "/deposit-staking/totals": totals,
  "/staking/settings/actual": stakingSettings,
  "/staking/active": active,
  "/staking/totals": totals,
  "/v2/p2p/v1/coins": coins,
});
